import React, {useContext} from 'react'
import {LocalMallRounded as LocalMallIcon} from '@mui/icons-material'
import {IconButton} from '@mui/material'
import {ItemBagContext} from '../../../context/ItemBagContext.jsx'
import {itemBag as textsItemsBag} from '../../../translate/Translate.jsx'

import './addBagBuyButton.scss'
import {getSession} from "../../../hooks/useStorage/useStorage.jsx";

const AddBagBuyButton = ({onClick}) => {
    const {total, isAddItem} = useContext(ItemBagContext)
    const allowOrder = getSession('allowOrder')

    //if (!allowOrder) return <div/>

    return <div className={'container-add-button'}>
        <div className={'div-add-button'}>
            <div className={'left'}>
                <label className={'label-price'} id={isAddItem ? 'add-item' : 'remove-item'}>
                    {total.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}
                </label>
            </div>
            {(allowOrder) && <div className={'right'}>
                <div className={'button'} onClick={() => onClick()}>
                    <label className={'label-add'}>
                        {textsItemsBag.addToCart}
                    </label>
                    <IconButton>
                        <LocalMallIcon className={'icon'}/>
                    </IconButton>
                </div>
            </div>}
        </div>
    </div>
}

export default AddBagBuyButton
